import { IPatientBirthdateRequest, PatientsBirthdateAction } from './patients.birthdate.date.types'

export const patientBirthdateRequest = (params: IPatientBirthdateRequest): PatientsBirthdateAction =>
  ({ type: 'PATIENT_BIRTHDATE_REQUEST', params })

export const patientBirthdateSuccess = (params: string): PatientsBirthdateAction =>
  ({ type: 'PATIENT_BIRTHDATE_SUCCESS', params })

export const patientBirthdateFailure = (): PatientsBirthdateAction =>
  ({ type: 'PATIENT_BIRTHDATE_FAILURE' })